module.exports = __webpack_public_path__ + "assets/img/9b424033ec6a483ff22ed7ce56d0e2d4.png";